import React from "react";
import {FormHelperText, Grid, MenuItem, Select, TextField} from "@mui/material";
import {ieri, iniann, oggi, ultann, ultmes, ultsett} from "../../utility/returnDate";

class FiltroSceltaData extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dataInizio: props.dataInizio,
            dataFine: props.dataFine,
            visualizzazione: 'Giornaliero',
            sceltaIntervallo: props.sceltaIntervallo,
            periodo: 1,
        }
    }

    componentDidMount() {
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event, provenienza) {

        if (provenienza === 'startDate') {
            this.props.handleChangeDataInizio(event.target.value);
            this.setState({dataInizio: event.target.value});
        }
        if (provenienza === 'endDate') {
            this.props.handleChangeDataFine(event.target.value);
            this.setState({dataFine: event.target.value});
        }
        if (provenienza === 'intervallo') {
            this.props.handleChangeDataInizio(event.target.value);
            this.setState({dataInizio: event.target.value});
            this.props.handleChangeDataFine(event.target.value);
            this.setState({dataFine: event.target.value});
        }
        if (provenienza === 'periodo') {
            let scelta = event.target.value;
            if (scelta === 1) {
                this.props.handleChangeDataInizio(oggi());
                this.props.handleChangeDataFine(oggi());
                this.setState({dataInizio: oggi(), dataFine: oggi()});
            }
            if (scelta === 2) {
                this.props.handleChangeDataInizio(ieri());
                this.props.handleChangeDataFine(ieri());
                this.setState({dataInizio: ieri(), dataFine: ieri()});
            }
            if (scelta === 3) {
                this.props.handleChangeDataInizio(ultsett());
                this.props.handleChangeDataFine(oggi());
                this.setState({dataInizio: ultsett(), dataFine: oggi()});
            }
            if (scelta === 4) {
                this.props.handleChangeDataInizio(ultmes());
                this.props.handleChangeDataFine(oggi());
                this.setState({dataInizio: ultmes(), dataFine: oggi()});
            }
            if (scelta === 5) {
                this.props.handleChangeDataInizio(ultann());
                this.props.handleChangeDataFine(oggi());
                this.setState({dataInizio: ultann(), dataFine: oggi()});
            }
            if (scelta === 6) {
                this.props.handleChangeDataInizio(iniann());
                this.props.handleChangeDataFine(oggi());
                this.setState({dataInizio: iniann(), dataFine: oggi()});
            }
            this.setState({periodo: event.target.value})
        }
    }

    render() {
        if (this.state.sceltaIntervallo === true) {
            return (
                <div className="elemento">
                    <Grid container direction="row" spacing={3}>
                        <Grid item>
                            <TextField m={3}
                                       id="startDate"
                                       label="Dal"
                                       type="date"
                                       name="startDate"
                                       value={this.state.dataInizio}
                                       defaultValue={this.state.dataInizio}
                                       onChange={(e) => this.handleChange(e, "startDate")}
                                       sx={{width: 220}}
                                       InputLabelProps={{
                                           shrink: true,
                                       }}
                            />
                        </Grid>
                        <Grid item>
                            <TextField m={3}
                                       id="endDate"
                                       label="Al"
                                       type="date"
                                       value={this.state.dataFine}
                                       defaultValue={this.state.dataFine}
                                       onChange={(e) => this.handleChange(e, "endDate")}
                                       sx={{width: 220}}
                                       InputLabelProps={{
                                           shrink: true,
                                       }}/>
                        </Grid>
                        <Grid item>
                            <Select
                                labelId="demo-simple-select-label"
                                id="selectOpt"
                                value={this.state.periodo}
                                onChange={(e) => this.handleChange(e, "periodo")}
                            >
                                <MenuItem value={1}>Oggi</MenuItem>
                                <MenuItem value={2}>Ieri </MenuItem>
                                <MenuItem value={3}>Ult.Settimana</MenuItem>
                                <MenuItem value={4}>Ult.mese</MenuItem>
                                <MenuItem value={5}>Ult.Anno</MenuItem>
                                <MenuItem value={6}>Da inizio anno</MenuItem>
                            </Select>
                            <FormHelperText>Scelta periodo</FormHelperText>

                        </Grid>
                    </Grid>
                </div>
            )
        } else {
            return (
                <div className="elemento">
                    <Grid container direction="row" spacing={3}>
                        <Grid item>
                            <TextField m={3}
                                       id="startDate"
                                       label="Data"
                                       type="date"
                                       name="startDate"
                                       value={this.state.dataInizio}
                                       defaultValue={this.state.dataInizio}
                                       onChange={(e) => this.handleChange(e, "intervallo")}
                                       sx={{width: 220}}
                                       InputLabelProps={{
                                           shrink: true,
                                       }}
                            />
                        </Grid>
                    </Grid>
                </div>
            )
        }

    }
}

export default FiltroSceltaData
